import PropTypes from 'prop-types';
import { DOWNVOTE, UPVOTE } from "../constants/vote-types";

export const VoteResource = {
    voter_user_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    election_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    type: PropTypes.oneOf([UPVOTE, DOWNVOTE]).isRequired,
};
